import React from "react";
import ImageWithFallback from "@components/ui/ImageFallback";
import { Time, Dumble, Dart } from "@utils/defaultImages";
import { useNavigate } from "react-router-dom";
import BackImg from "@assets/images/stepsBack.jpg";
import { useTranslation } from "react-i18next";
import TrainingFocusChart from "./TrainingFocusChart"; 

const ExercisePlanView = ({ exerciseData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleNavigateDetail = () => {
    navigate("/exercise-plan/view-plan", {
      state: { day: exerciseData?.day },
    });
  };
  const data = exerciseData?.data;
  return (
    <div
      className="bg-cover relative rounded-[12px]  p-6 "
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="space-y-4 flex flex-col h-full">
        <h2 className="text-white font-[Lato] text-[16px]">
          {t("dashboard.exerciseDashboardHeading")}
        </h2>

        <div className="bg-white rounded-[16px] p-3 md:p-2 flex flex-col md:flex-row items-center gap-2 lg:gap-4">
          <ImageWithFallback
            src={`${data?.image_url}`}
            exercisePlan={true}
            anonymous={false}
            className="w-full md:w-[163px] h-[190px] object-cover rounded-[13px]"
          />
          <div className="w-full p-0 py-1 flex-1">
            <p className="text-[14px] font-[Lato] font-[600] mb-2">
              {data?.title}
            </p>
            <div className=" space-y-2 ">
              <button className="text-[#4CA842]  text-[12px] bg-[#D7FFD2] rounded-full px-2 py-1 flex items-center gap-2 w-full">
                <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                  <Time />
                </p>{" "}
                {data?.duration}
              </button>
              <button className="text-[#E58B00]  text-[12px] bg-[#D2FCFF] rounded-full px-2 py-1 flex items-center gap-2 w-full">
                <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                  <Dumble />
                </p>{" "}
                {t(`exercisePlan.Type`)}: {data?.category}
              </button>
            </div>
            <div className=" space-y-2 my-2">
              {/* <button className="text-[#00B7FE]  text-[12px] bg-[#D2FCFF] rounded-full px-2 py-1 flex items-center gap-2 w-[fit-content] flex-1">
                    <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                      <Loc />
                    </p>{" "}
                    {t(`exercisePlan.Location`)}: {data?.location}
                  </button> */}
              <button className="text-[#E50067] text-[12px] bg-[#FBDBEB] rounded-full px-2 py-1 flex items-center gap-2 w-full">
                <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                  <Dart />
                </p>{" "}
                {t(`exercisePlan.Goal`)}: {data?.goals}
              </button>
            </div>
            <button
              className="w-full text-white bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[4px] py-2 text-[12px] font-[500]"
              onClick={() => handleNavigateDetail(data)}
            >
              {t(`exercisePlan.viewPlan`)}
            </button>
          </div>
        </div>

        {/* <div className="bg-white rounded-[16px]">
          <TrainingFocusChart />
        </div> */}
        <div className="flex-1">
            <video
              className="w-full h-full rounded-md shadow-lg object-cover"
              src={exerciseData?.video_url}
              poster={exerciseData?.data?.image_url}
              playsInline
              controls
            />
          </div>
      </div>
    </div>
  );
};

export default ExercisePlanView;
